import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
        padding: '40px',
        fontSize: '11px',
        fontFamily: 'Helvetica',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        borderBottomWidth: 2,
        borderBottomColor: '#000',
        paddingBottom: '12px',
        marginBottom: '20px',
    },
    headerLeft: {
        fontSize: '18px',
        fontWeight: 'bold',
    },
    headerRight: {
        textAlign: 'right',
        fontSize: '11px',
    },
    headerRightLabel: {
        fontSize: '11px',
        color: '#666',
        fontWeight: '500',
    },
    sectionTitle: {
        fontSize: '11px',
        fontWeight: 'bold',
        marginTop: '12px',
        marginBottom: '4px',
    },
    customerName: {
        fontSize: '9px',
        fontWeight: 'bold',
        marginBottom: '4px',
    },
    sectionContent: {
        fontSize: '10px',
        marginBottom: '12px',
        lineHeight: 1.4,
    },
    twoColumn: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '20px',
    },
    column: {
        width: '48%',
    },
    divider: {
        borderBottomWidth: 1,
        borderBottomColor: '#000',
        marginVertical: '4px',
    },
    summaryRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: '8px',
        // marginBottom: '12px',
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    summaryItem: {
        flex: 1,
    },
    summaryLabel: {
        fontSize: '9px',
        color: '#666',
    },
    summaryValue: {
        fontSize: '10px',
        fontWeight: 'bold',
    },
    orderHeaderRow: {
        flexDirection: 'row',
        // marginTop: '16px',
        marginBottom: '0px',
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    orderHeaderCell: {
        flex: 1,
        padding: '6px 8px',
        fontSize: '11px',
        textAlign: 'center',
        fontWeight: '700',
    },
    orderHeaderCellLast: {},
    orderDataRow: {
        flexDirection: 'row',
        backgroundColor: '#d9d9d9',
        padding: '6px 6px',
        // marginBottom: '8px',
    },
    orderDataCell: {
        flex: 1,
        fontSize: '10px',
        textAlign: 'center',
    },
    orderDataCellFirst: {
        textAlign: 'left',
    },
    orderSection: {
        flexDirection: 'row',
        marginTop: '4px',
        // marginBottom: '12px',
    },
    customerInfo: {
        width: '30%',
        paddingRight: '10px',
    },
    itemsSection: {
        width: '70%',
        paddingLeft: '10px',
    },
    customerLabel: {
        fontSize: '8px',
        color: '#666',
        marginTop: '4px',
        marginBottom: '1px',
        fontWeight: '500',
    },
    customerValue: {
        fontSize: '8px',
        marginBottom: '6px',
        lineHeight: 1.2,
    },
    tableContainer: {
        fontSize: '8px',
        borderTopWidth: 1,
        borderTopColor: '#000',
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#000',
        minHeight: 'auto',
    },
    tableLastRow: {
        flexDirection: 'row',
    },
    tableHeader: {
        flexDirection: 'row',
        fontWeight: 'bold',
        backgroundColor: '#f0f0f0',
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    tableCell: {
        padding: '2px 1px',
        textAlign: 'center',
        fontSize: '6px',
        lineHeight: 1.2,
    },
    tableCellLast: {},
    tableCellLeft: {
        textAlign: 'left',
    },
    tableCellSmall: {
        width: '7%',
    },
    tableCellMedium: {
        width: '28%',
    },
    tableCellLarge: {
        width: '28%',
    },
    tableCellSKU: {
        width: '12%',
    },
    // pageBreak: {
    //     marginTop: '20px',
    // },
});

const ManifestPDF = ({ pdfData, includeItemDetails }) => {
    return (
        <Document>
            <Page size="LETTER" style={styles.page} wrap>
                {/* Header */}
                <View style={styles.header}>
                    <View>
                        {/* <Text style={styles.headerLeft}>{pdfData.warehouse_name}</Text> */}
                        <Text style={styles.headerLeft}>{pdfData.carrier}</Text>
                    </View>
                    <View>
                        {/* <Text style={styles.headerRight}>
                            <Text style={styles.headerRightLabel}>Manifest: {pdfData.route_number}</Text>
                        </Text> */}
                        <Text style={styles.headerRight}>
                            <Text style={styles.headerRightLabel}>
                                Route: {pdfData.route_alias || pdfData.route_number}
                            </Text>
                        </Text>
                        <Text style={styles.headerRight}>
                            <Text style={styles.headerRightLabel}>Issued: {pdfData.issue_date}</Text>
                        </Text>
                    </View>
                </View>

                {/* Departure and Destination */}
                <View style={styles.twoColumn}>
                    <View style={styles.column}>
                        <Text style={styles.sectionTitle}>Departure</Text>
                        <Text style={styles.sectionContent}>{pdfData.departure_address}</Text>
                        <Text style={styles.sectionContent}>
                            Date:{' '}
                            {new Date().toLocaleDateString('en-US', {
                                month: '2-digit',
                                day: '2-digit',
                                year: '2-digit',
                            })}
                        </Text>
                    </View>
                    <View style={styles.column}>
                        <Text style={styles.sectionTitle}>Destination</Text>
                        <Text style={styles.sectionContent}>{pdfData.destination_address}</Text>
                        <Text style={styles.sectionContent}>Est Arrival: N/A</Text>
                    </View>
                </View>

                <View style={styles.divider} />

                {/* Summary Row */}
                <View style={styles.summaryRow}>
                    <View style={styles.summaryItem}>
                        <Text style={styles.summaryLabel}>Resource:</Text>
                        <Text style={styles.summaryValue}>{pdfData.resource}</Text>
                    </View>
                    <View style={styles.summaryItem}>
                        <Text style={styles.summaryLabel}>Carrier:</Text>
                        <Text style={styles.summaryValue}>{pdfData.carrier}</Text>
                    </View>
                    <View style={styles.summaryItem}>
                        <Text style={styles.summaryLabel}>Assignee:</Text>
                        <Text style={styles.summaryValue}>{pdfData.assignee}</Text>
                    </View>
                </View>

                {/* Orders */}
                {pdfData.orders.map((order, orderIndex) => {
                    const totalItems = order.items.length;
                    const totalWeight = order.items.reduce((sum, item) => {
                        const weight = parseInt(item.weight) || 0;
                        return sum + weight;
                    }, 0);
                    const totalCubes = order.items.reduce((sum, item) => {
                        const cubes = parseInt(item.cubes) || 0;
                        return sum + cubes;
                    }, 0);

                    return (
                        <View key={order.order_number} style={orderIndex > 0 ? styles.pageBreak : {}}>
                            {/* Order Header Row */}
                            <View style={styles.orderHeaderRow}>
                                <Text style={styles.orderHeaderCell}>Order</Text>
                                <Text style={styles.orderHeaderCell}>Items</Text>
                                <Text style={styles.orderHeaderCell}>Weight</Text>
                                <Text style={{ ...styles.orderHeaderCell, ...styles.orderHeaderCellLast }}>Cubes</Text>
                            </View>

                            {/* Order Data Row */}
                            <View style={styles.orderDataRow}>
                                <Text style={{ ...styles.orderDataCell, ...styles.orderDataCellFirst }}>
                                    {order.stop_number} - {order.order_number}{' '}
                                    {order.po_number ? `/ ${order.po_number}` : ''}
                                </Text>
                                <Text style={styles.orderDataCell}>{totalItems}</Text>
                                <Text style={styles.orderDataCell}>{totalWeight}</Text>
                                <Text style={styles.orderDataCell}>{totalCubes}</Text>
                            </View>

                            {/* Order Section */}
                            {includeItemDetails && order.items.length > 0 ? (
                                <View style={styles.orderSection}>
                                    {/* Customer Info */}
                                    <View style={styles.customerInfo}>
                                        <Text style={styles.customerName}>{order.customer_name}</Text>
                                        <View>
                                            <Text style={styles.customerLabel}>Phone</Text>
                                            <Text style={styles.customerValue}>{order.customer_phone}</Text>

                                            <Text style={styles.customerLabel}>Address</Text>
                                            <Text style={styles.customerValue}>{order.customer_address}</Text>

                                            <Text style={styles.customerLabel}>Time Frame</Text>
                                            <Text style={styles.customerValue}>{order.time_frame}</Text>
                                        </View>
                                    </View>

                                    {/* Items Table */}
                                    <View style={styles.itemsSection}>
                                        <View style={styles.tableContainer}>
                                            {/* Table Header */}
                                            <View style={styles.tableHeader}>
                                                <Text
                                                    style={{
                                                        ...styles.tableCell,
                                                        ...styles.tableCellSmall,
                                                        ...styles.tableCellLeft,
                                                    }}
                                                >
                                                    ID
                                                </Text>
                                                <Text style={{ ...styles.tableCell, ...styles.tableCellSKU }}>SKU</Text>
                                                <Text
                                                    style={{
                                                        ...styles.tableCell,
                                                        ...styles.tableCellLarge,
                                                        ...styles.tableCellLeft,
                                                    }}
                                                >
                                                    Description
                                                </Text>
                                                <Text style={{ ...styles.tableCell, ...styles.tableCellMedium }}>
                                                    Barcode
                                                </Text>
                                                <Text style={{ ...styles.tableCell, ...styles.tableCellSmall }}>
                                                    Weight
                                                </Text>
                                                <Text
                                                    style={{
                                                        ...styles.tableCell,
                                                        ...styles.tableCellSmall,
                                                        ...styles.tableCellLast,
                                                    }}
                                                >
                                                    Cubes
                                                </Text>
                                            </View>

                                            {/* Table Rows */}
                                            {order.items.map((item, itemIndex) => (
                                                <View
                                                    key={item.item_id}
                                                    style={
                                                        itemIndex === order.items.length - 1
                                                            ? styles.tableLastRow
                                                            : styles.tableRow
                                                    }
                                                >
                                                    <View style={{ ...styles.tableCell, ...styles.tableCellSmall }}>
                                                        <Text style={styles.tableCellLeft}>
                                                            {item.item_id.substring(0, 10)}
                                                        </Text>
                                                    </View>
                                                    <View style={{ ...styles.tableCell, ...styles.tableCellSKU }}>
                                                        <Text>{item.sku}</Text>
                                                    </View>
                                                    <View style={{ ...styles.tableCell, ...styles.tableCellLarge }}>
                                                        <Text style={styles.tableCellLeft}>{item.description}</Text>
                                                    </View>
                                                    <View style={{ ...styles.tableCell, ...styles.tableCellMedium }}>
                                                        <Text>{item.barcode}</Text>
                                                    </View>
                                                    <View style={{ ...styles.tableCell, ...styles.tableCellSmall }}>
                                                        <Text>{item.weight}</Text>
                                                    </View>
                                                    <View
                                                        style={{
                                                            ...styles.tableCell,
                                                            ...styles.tableCellSmall,
                                                            ...styles.tableCellLast,
                                                        }}
                                                    >
                                                        <Text>{item.cubes}</Text>
                                                    </View>
                                                </View>
                                            ))}
                                        </View>
                                    </View>
                                </View>
                            ) : (
                                <View style={{ marginBottom: '12px' }}>
                                    <Text style={styles.customerName}>{order.customer_name}</Text>
                                    <View>
                                        <Text style={styles.customerLabel}>Phone</Text>
                                        <Text style={styles.customerValue}>{order.customer_phone}</Text>

                                        <Text style={styles.customerLabel}>Address</Text>
                                        <Text style={styles.customerValue}>{order.customer_address}</Text>

                                        <Text style={styles.customerLabel}>Time Frame</Text>
                                        <Text style={styles.customerValue}>{order.time_frame}</Text>
                                    </View>
                                </View>
                            )}

                            {orderIndex < pdfData.orders.length - 1 && <View style={styles.divider} />}
                        </View>
                    );
                })}
            </Page>
        </Document>
    );
};

export default ManifestPDF;
